export const CUSTODIANS_UPDATED = "CUSTODIANS_UPDATED";
export const GET_CUSTODIANS = "GET_CUSTODIANS";
export const GET_CUSTODIANS_ERROR = "GET_CUSTODIANS_ERROR";

export const BDS_UPDATED = "BDS_UPDATED";
export const GET_BDS = "GET_BDS";
export const GET_BDS_ERROR = "GET_BDS_ERROR";

export const RIAS_UPDATED = "RIAS_UPDATED";
export const GET_RIAS = "GET_RIAS";
export const GET_RIAS_ERROR = "GET_RIAS_ERROR";

export const AGENTS_UPDATED = "AGENTS_UPDATED";
export const GET_AGENTS = "GET_AGENTS";
export const GET_AGENTS_ERROR = "GET_AGENTS_ERROR";

export const CLIENTS_UPDATED = "CLIENTS_UPDATED";
export const GET_CLIENTS = "GET_CLIENTS";
export const GET_CLIENTS_ERROR = "GET_CLIENTS_ERROR";

export const GROUPS_UPDATED = "GROUPS_UPDATED";
export const GET_GROUPS = "GET_GROUPS";
export const GET_GROUPS_ERROR = "GET_GROUPS_ERROR";
